import React from 'react';
import CustomSelect from './index';

const getLabel = ({ name, vintage, showVintages }) =>
  showVintages ? `${vintage} - ${name}` : name;

const parseValue = (value) => {
  const [id, name, vintage] = value.split('~');
  return { id, name, vintage };
};

const stringifyValue = ({ id, name, vintage }) => `${id}~${name}~${vintage}`;

const SelectWineVintage = ({
  onChange,
  value, // type: { id: string, name: string, vintage: string } || [{ id: string, name: string, vintage: string }]
  vintagesByWine, // type: { wine_id: { name: string, vintages: [string] }
  showVintages,
  isMulti = false,
  placeholder
}) => {
  const multiMaxValues = 5;

  const getOneOption = (id) =>
    showVintages
      ? {
          label: vintagesByWine[id].name,
          options: vintagesByWine[id].vintages.map((vintage) => ({
            label: getLabel({
              name: vintagesByWine[id].name,
              vintage,
              showVintages
            }),
            value: stringifyValue({
              id,
              name: vintagesByWine[id].name,
              vintage
            })
          }))
        }
      : {
          label: getLabel({ name: vintagesByWine[id].name, showVintages }),
          value: stringifyValue({
            id,
            name: vintagesByWine[id].name,
            vintage: vintagesByWine[id].vintages[0]
          })
        };

  const options = Object.keys(vintagesByWine)
    // Filter wines without vintages
    .filter((id) => vintagesByWine[id].vintages.length > 0)
    .map((id) => getOneOption(id));

  const getOneValue = ({ id, vintage }) =>
    id && vintage && vintagesByWine[id]
      ? {
          label: getLabel({
            name: vintagesByWine[id].name,
            vintage,
            showVintages
          }),
          value: stringifyValue({ id, name: vintagesByWine[id].name, vintage })
        }
      : null;

  const localValue = !value
    ? null
    : isMulti
      ? value.map((v) => getOneValue(v))
      : getOneValue(value);

  const localOnChange = (option) => {
    let value = null;
    if (option) {
      value = isMulti
        ? option.map((o) => parseValue(o.value))
        : parseValue(option.value);
    }

    if (isMulti) {
      // Limit to 5 values
      value =
        value.length > multiMaxValues ? value.slice(1, value.length) : value;
    }

    onChange(value);
  };

  const customStyles = {
    control: {
      height: 40,
      minHeight: 40,
      width: isMulti ? 500 : 300,
      padding: 0
    },
    container: {
      width: isMulti ? 500 : 300,
      height: 40,
      padding: 0
    },
    groupHeading: {
      color: '#2B3D54',
      fontSize: '100%'
    },
    menuList: {
      width: '100%',
      boxShadow: '4px 4px 9px 2px hsl(0,0%,70%)'
    },
    option: {
      padding: '8px 20px'
    },
    valueContainer: {
      maxHeight: '100px',
      height: '40px !important',
      padding: 0
    }
  };

  return (
    <CustomSelect
      value={localValue}
      options={options}
      onChange={(selectedOption) => localOnChange(selectedOption)}
      placeholder={placeholder}
      customStyles={customStyles}
      dropdownProps={{
        styles: (isMulti ? value && value.length > 0 : value)
          ? `margin-left:0px`
          : `margin-left:-25px`
      }}
      isClearable={true}
      clearProps={{
        styles: `margin-left:-50px`
      }}
      isMulti={isMulti}
    />
  );
};

export default SelectWineVintage;
